import deepMerge from 'deepmerge';

import credentialsForm from '@bundles/ApiSettings/components/CredentialsForm/translations';
import apiSettings from '@bundles/ApiSettings/translations';
import dataFormats from '@bundles/DataFormats/translations';
import aggregates from '@bundles/Filing/Aggregates/translations';
import dataRow from '@bundles/Filing/components/SummaryTable/components/DataRow/translations';
import summaryTable from '@bundles/Filing/components/SummaryTable/translations';
import dataRowECSL from '@bundles/Filing/components/SummaryTableECSL/components/DataRowECSL/translations';
import summaryTableECSL from '@bundles/Filing/components/SummaryTableECSL/translations';
import inviteUserForm from '@bundles/InviteUser/components/InviteUserForm/translations';
import sideNav from '@bundles/Layout/primaryMenu/translations';
import backToLogin from '@bundles/Login/components/BackToLogin/translations';
import forgotEmailPanel from '@bundles/Login/components/ForgotEmailPanel/translations';
import forgotPasswordForm from '@bundles/Login/components/ForgotPasswordForm/translations';
import forgotPasswordPanel from '@bundles/Login/components/ForgotPasswordPanel/translations';
import loginForm from '@bundles/Login/components/LoginForm/translations';
import loginPanel from '@bundles/Login/components/LoginPanel/translations';
import resetPasswordForm from '@bundles/Login/components/ResetPasswordForm/translations';
import resetPasswordPanel from '@bundles/Login/components/ResetPasswordPanel/translations';
import twoFactorSetupForm from '@bundles/Login/components/TwoFactorSetupForm/translations';
import twoFactorSetupPanel from '@bundles/Login/components/TwoFactorSetupPanel/translations';
import participantSelector from '@bundles/Messages/MessageDisplay/ParticipantSelector/translations';
import messageList from '@bundles/Messages/MessageList/translations';
import polishSkuList from '@bundles/PolishSku/components/PolishSkuList/translations';
import polishSkuListItem from '@bundles/PolishSku/components/PolishSkuListItem/translations';
import polishSku from '@bundles/PolishSku/translations';
import mapping from '@bundles/Registrations/ConversionToolSettings/MappingPage/translations';
import jurisdictionsListItem from '@bundles/Registrations/JurisdictionsListPage/components/JurisdictionsListItem/translations';
import registrationsDeRegisterDrawer from '@bundles/Registrations/RegistrationsDeRegisterDrawer/translations';
import filingTypesForm from '@bundles/Registrations/RegistrationsDetailPage/components/FilingTypes/components/FilingTypesForm/translations';
import registrationFilingTypesList from '@bundles/Registrations/RegistrationsDetailPage/components/FilingTypes/components/FilingTypesList/translations';
import registrationFilingTypesListItem from '@bundles/Registrations/RegistrationsDetailPage/components/FilingTypes/components/FilingTypesListItem/translations';
import registrationFilingTypes from '@bundles/Registrations/RegistrationsDetailPage/components/FilingTypes/translations';
import registrationsDeRegisterForm from '@bundles/Registrations/RegistrationsDetailPage/components/RegistrationDeRegisterForm/translations';
import registrationInfoForm from '@bundles/Registrations/RegistrationsDetailPage/components/RegistrationInfoForm/translations';
import registrationDetailsPage from '@bundles/Registrations/RegistrationsDetailPage/translations';
import registrationFormDrawer from '@bundles/Registrations/RegistrationsFormDrawer/translations';
import registrationListItem from '@bundles/Registrations/RegistrationsListPage/components/RegistrationListItem/translations';
import registrationsListPage from '@bundles/Registrations/RegistrationsListPage/translations';
import skuList from '@bundles/SKUPage/components/SKUList/translations';
import skuPage from '@bundles/SKUPage/translations';
import permissionsTabContent from '@bundles/Users/UsersDetail/components/PermissionsTabContent/translations';
import permissionsTable from '@bundles/Users/UsersDetail/components/PermissionsTable/translations';
import registrationAccess from '@bundles/Users/UsersDetail/components/RegistrationAccess/translations';
import registrationAccessSelector from '@bundles/Users/UsersDetail/components/RegistrationAccessSelector/translations';
import roleForm from '@bundles/Users/UsersDetail/components/RoleForm/translations';
import multiCountrySelector from '@components-legacy/MultiCountrySelector/translations';
import dragDropModal from '@components/DragDropModal';
import error from '@components/Error/translations';
import fileList from '@components/FileList/translations';
import navigationPrompt from '@components/NavigationPrompt/translations';
import privacyPolicy from '@components/PrivacyPolicy/translations';
import referenceCaptureModal from '@components/ReferenceCaptureModal/translations';
import referenceDisplayModal from '@components/ReferenceDisplayModal/translations';
import termsAndConditions from '@components/TermsAndConditions/translations';
import filingFiles from '@pages/Filing/components/FilingFiles/translations';
import conversionSettingsForm from '@pages/Filing/ConversionTool/MappingSteps/CTStepOne/components/ConversionSettingsForm/translations';
import filingHeader from '@pages/Filing/FilingDetailPage/components/FilingHeader/translations';
import filingOutcomeForm from '@pages/Filing/FilingDetailPage/components/FilingOutcome/components/FilingOutcomeForm/translations';
import paymentDetailsDrawer from '@pages/Filing/FilingDetailPage/components/FilingOutcome/components/PaymentDetailsDrawer/translations';
import paymentDetailsForm from '@pages/Filing/FilingDetailPage/components/FilingOutcome/components/PaymentDetailsForm/translations';
import filingOutcome from '@pages/Filing/FilingDetailPage/components/FilingOutcome/translations';
import confirmationModal from '@pages/Filing/FilingDetailPage/components/FilingSubmission/components/ConfirmationModal/translations';
import filingTabs from '@pages/Filing/FilingDetailPage/components/FilingTabs/translations';
import distanceSalesSelector from '@pages/Filing/GameChangerPage/components/DistanceSalesSelector/translations';
import conversionTutorialModal from '@pages/Filing/UploadData/components/TutorialModal/translations';
import mappingConversionModal from '@pages/Filing/UploadData/MappingConversionModal/translations';

import bankingDetailsForm from './banking-details-form';
import colourPicker from './colour-picker';
import companySignUpForm from './company-sign-up-form';
import entitySelector from './entity-selector';
import global from './global';
import header from './header';
import individualSignUpForm from './individual-sign-up-form';
import multiSelector from './multi-selector';
import spreadsheet from './spreadsheet';
import topNav from './top-nav';

export default deepMerge.all([
  apiSettings,
  aggregates,
  backToLogin,
  bankingDetailsForm,
  colourPicker,
  companySignUpForm,
  conversionSettingsForm,
  conversionTutorialModal,
  credentialsForm,
  dataFormats,
  dataRow,
  dataRowECSL,
  dragDropModal,
  entitySelector,
  error,
  fileList,
  filingFiles,
  filingHeader,
  filingTabs,
  filingTypesForm,
  forgotEmailPanel,
  forgotPasswordForm,
  forgotPasswordPanel,
  global,
  header,
  individualSignUpForm,
  inviteUserForm,
  jurisdictionsListItem,
  loginForm,
  loginPanel,
  resetPasswordForm,
  resetPasswordPanel,
  mapping,
  mappingConversionModal,
  messageList,
  multiSelector,
  registrationsListPage,
  multiCountrySelector,
  navigationPrompt,
  participantSelector,
  paymentDetailsDrawer,
  paymentDetailsForm,
  permissionsTable,
  permissionsTabContent,
  polishSku,
  polishSkuList,
  polishSkuListItem,
  privacyPolicy,
  referenceCaptureModal,
  referenceDisplayModal,
  registrationAccess,
  registrationAccessSelector,
  registrationListItem,
  registrationDetailsPage,
  registrationsDeRegisterDrawer,
  registrationsDeRegisterForm,
  registrationFilingTypes,
  registrationFilingTypesList,
  registrationFilingTypesListItem,
  registrationFormDrawer,
  registrationInfoForm,
  roleForm,
  sideNav,
  skuList,
  skuPage,
  spreadsheet,
  summaryTable,
  summaryTableECSL,
  termsAndConditions,
  topNav,
  twoFactorSetupForm,
  twoFactorSetupPanel,
  filingOutcomeForm,
  filingOutcome,
  confirmationModal,
  distanceSalesSelector,
]);
